/**
 * 认证路由配置
 */
import type { Locale } from '~/lib/i18n/shared'
import { defaultLocale, resolveImplementedLocale } from '~/lib/i18n/shared'

export const AUTH_ROUTES = {
  signIn: 'sign-in',
  signUp: 'sign-up',
  forgotPassword: 'forgot-password',
  resetPassword: 'reset-password',
  verifyEmail: 'verify-email',
  resendEmail: 'resend-email',
} as const

export const AUTH_BASE_PATH = '/auth'

export type AuthRoute = typeof AUTH_ROUTES[keyof typeof AUTH_ROUTES]

export function getAuthRoute(route: AuthRoute): string {
  return `${AUTH_BASE_PATH}/${route}`
}

export function getAuthBasePath(locale: Locale | string | null | undefined): string {
  return resolveImplementedLocale(locale) === defaultLocale ? AUTH_BASE_PATH : `/${resolveImplementedLocale(locale)}${AUTH_BASE_PATH}`
}

export function getAuthRouteTarget(locale: Locale | string | null | undefined, route: AuthRoute): {
  to: '/auth/$pathname' | '/$locale/auth/$pathname'
  params: { pathname: AuthRoute } | { locale: Locale, pathname: AuthRoute }
} {
  const implementedLocale = resolveImplementedLocale(locale)
  if (implementedLocale === defaultLocale) {
    return {
      to: '/auth/$pathname',
      params: { pathname: route },
    }
  }

  return {
    to: '/$locale/auth/$pathname',
    params: { locale: implementedLocale, pathname: route },
  }
}
